<template>
    <div v-if="restaurantId" class="delete-token">
        <v-btn color="warning" @click="confirmModal = true">
            {{ $t('labels.delete_token') }}
        </v-btn>
        <confirm-modal
            :value="confirmModal"
            :text="$t('texts.are_you_sure_you_want_to_delete_the_token')"
            :processing="processing"
            @onApprove="onApprove"
            @onCancel="onCancel"
        ></confirm-modal>
    </div>
</template>

<style scoped>
.delete-token {
    display: inline-block;
}
</style>

<script>
import ConfirmModal from '@/components/confirm/ConfirmModal'
import RestaurantsApiClient from '@/api/RestApi/RestaurantsApiClient'

export default {
    components: {
        ConfirmModal,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        restaurantId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            confirmModal: false,
            processing: false,
        }
    },
    methods: {
        onApprove() {
            this.processing = true
            RestaurantsApiClient.deleteAccessToken(this.restaurantId)
                .then(() => {
                    this.$emit('input', null)
                })
                .finally(() => {
                    this.close()
                })
        },
        onCancel() {
            this.close()
        },
        close() {
            this.processing = false
            this.confirmModal = false
        },
    },
}
</script>
